import { IBlockDataModelConstructor } from '../../../interface/block/block-data-contructor.interface';

export const quickEditBlock = (quickEditProperties: string[]) => (blockDataModel: IBlockDataModelConstructor) => {
  blockDataModel.showQuickEdit = quickEditProperties;
  return blockDataModel;
};
